import WeaveConfirmationModal from './WeaveConfirmationModal';

export default WeaveConfirmationModal;
